import React from 'react';

import AppLayout from './AppLayout';
import AppearTransition from './AppearTransition';

export default function Loading() {
  return <AppLayout>
    <div className='App-loading'>
      <AppearTransition animation='fadeIn'>
        <div className='animated App-spinner-wrapper'>
          <div className='App-spinner'></div>
        </div>
      </AppearTransition>
    </div>
  </AppLayout>
}



// WEBPACK FOOTER //
// ./src/lib/Loading.js